import { IconArrowDecrease, IconArrowIncrease, IconProps, semantic_colors } from '@croquiscom/pds';
import { isNumber } from 'class-validator';
import { FC } from 'react';

interface Props extends IconProps {
  sign: number;
}

export const IconVariationSign: FC<Props> = ({
  sign,
  color = sign > 0 ? semantic_colors.state.negative : semantic_colors.accent.primary,
  ...rest
}) => {
  if (sign === 0 || !isNumber(sign)) {
    return null;
  }
  if (sign > 0) {
    return <IconArrowIncrease {...rest} color={color} />;
  }
  return <IconArrowDecrease {...rest} color={color} />;
};
